import { createValidIcon } from '@ui/icons/utils/type-helper'

export const StatusReviewingIcon = createValidIcon((props) => {
  const { size, color } = props

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size}
      viewBox='0 0 20 20'
      fill='none'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M5.69183 1.96437C5.98767 2.31693 5.94168 2.84256 5.58912 3.13839L3.03563 5.28102C2.68307 5.57685 2.15744 5.53087 1.86161 5.17831C1.56577 4.82574 1.61176 4.30011 1.96432 4.00428L4.5178 1.86165C4.87037 1.56582 5.396 1.61181 5.69183 1.96437ZM14.3112 1.96437C14.607 1.61181 15.1326 1.56582 15.4852 1.86165L18.0387 4.00428C18.3912 4.30011 18.4372 4.82574 18.1414 5.17831C17.8455 5.53087 17.3199 5.57685 16.9673 5.28102L14.4139 3.13839C14.0613 2.84256 14.0153 2.31693 14.3112 1.96437ZM9.99998 5.00002C6.77832 5.00002 4.16665 7.6117 4.16665 10.8334C4.16665 14.055 6.77832 16.6667 9.99998 16.6667C13.2216 16.6667 15.8333 14.055 15.8333 10.8334C15.8333 7.6117 13.2216 5.00002 9.99998 5.00002ZM2.49998 10.8334C2.49998 6.69122 5.85784 3.33336 9.99998 3.33336C14.1421 3.33336 17.5 6.69122 17.5 10.8334C17.5 14.9755 14.1421 18.3334 9.99998 18.3334C5.85784 18.3334 2.49998 14.9755 2.49998 10.8334ZM9.99998 5.83336C10.4602 5.83336 10.8333 6.20645 10.8333 6.66669V10H14.1666C14.6269 10 15 10.3731 15 10.8334C15 11.2936 14.6269 11.6667 14.1666 11.6667H9.99998C9.53974 11.6667 9.16664 11.2936 9.16664 10.8334V6.66669C9.16664 6.20645 9.53974 5.83336 9.99998 5.83336Z'
        fill={color}
      />
    </svg>
  )
})
